import { IndicatorName } from '@/api/rest/resources/types/fact';
import { GraphFact } from '@/components/Charts/types';
import { isNullish } from '@/utils/booleans';

const byDate = (a: GraphFact, b: GraphFact) => new Date(a.date).getTime() - new Date(b.date).getTime();

/**
 * Creates a forecast point at the last observation preceding the forecast so the two lines connect.
 */
const getForecastBridgePoint = (historicData: GraphFact[], forecastData: GraphFact[]): GraphFact[] => {
  const firstForecast = forecastData
    .filter((fact) => fact.name === IndicatorName.lst_forecast && !isNullish(fact.value))
    .sort(byDate)
    .at(0);
  if (!firstForecast) return [];

  const lastObserved = historicData
    .filter(
      (fact) =>
        fact.name === IndicatorName.lst &&
        !isNullish(fact.value) &&
        new Date(fact.date).getTime() < new Date(firstForecast.date).getTime(),
    )
    .sort(byDate)
    .at(-1);
  if (!lastObserved) return [];

  return [
    { date: lastObserved.date, name: IndicatorName.lst_forecast, unit: lastObserved.unit, value: lastObserved.value },
  ];
};

export const getLstGraphData = (
  historicData: GraphFact[],
  forecastData: GraphFact[] | null | undefined,
  benchmarkData: GraphFact[] | null | undefined,
): GraphFact[] => {
  const forecast = forecastData ?? [];

  return [
    ...historicData,
    ...forecast,
    ...getForecastBridgePoint(historicData, forecast),
    ...(benchmarkData ?? []).map((fact) => ({ ...fact, name: IndicatorName.lst_benchmark })),
  ];
};
